import { all } from 'redux-saga/effects'
import { acceptSaga } from './accept/sagas'
import { declineSaga } from './decline/sagas'
import { hireSaga } from './hire/sagas'

export function* bookingCandidateSaga() {
  yield all([hireSaga(), acceptSaga(), declineSaga()])
}
